import React from 'react';
import { colors } from '../theme/tokens';

// Small local boundary for the image cropper. If anything inside throws,
// we render a friendly recovery card and leave the rest of the page alone.
// Includes an onRetake callback so the user can immediately retry with a fresh photo.
class CropperErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[CropperErrorBoundary] cropper error:', error, info);
  }

  reset = () => {
    this.setState({ hasError: false, error: null });
    if (this.props.onReset) this.props.onReset();
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={styles.card}>
        <div style={styles.icon}>⚠️</div>
        <div style={styles.title}>Couldn't load the cropper</div>
        <div style={styles.msg}>The rest of the page still works. Tap below to try with a fresh photo.</div>
        {this.state.error && this.state.error.message && (
          <div style={styles.detail}>{this.state.error.message}</div>
        )}
        <button type="button" style={styles.btn} onClick={this.reset}>↺ Try again</button>
      </div>
    );
  }
}

const styles = {
  card: {
    background: colors.surface,
    border: `1px solid ${colors.amber}`,
    borderRadius: 12,
    padding: 20,
    textAlign: 'center'
  },
  icon: { fontSize: 28, marginBottom: 8 },
  title: { fontSize: 15, fontWeight: 700, color: colors.text, marginBottom: 6 },
  msg: { fontSize: 13, color: colors.textMuted, marginBottom: 8 },
  detail: { fontSize: 11, color: colors.textMuted, fontStyle: 'italic', marginBottom: 12 },
  btn: {
    background: '#ea580c', color: 'white', border: 'none', borderRadius: 6,
    padding: '8px 18px', cursor: 'pointer', fontWeight: 600, fontSize: 13
  }
};

export default CropperErrorBoundary;
